<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
    <div id="fb-root"></div>
    <!-- Your customer chat code -->
    <div class="fb-customerchat"
         attribution=setup_tool
         page_id="360179007717640"
         theme_color="#BAA069"
         logged_in_greeting="搜飾盒是全新珠寶換戴平台，請問有什麼可以幫到你？"
         logged_out_greeting="搜飾盒是全新珠寶換戴平台，請問有什麼可以幫到你？">
    </div>
  </div>
</template>

<script>
  import JewelleryHome from '@/views/viewHK/JewelleryHome'
  import Search from '@/views/viewHK/Search'

  export default {
    name: 'App',
    components: {
      JewelleryHome,
      Search,
    },
    data() {
      return {
        activeIndex: '1',
        activeIndex2: '1',
        activeName: 'first',
        itemW: 0,
        paddingNum: '',
        mr: '',

      };
    },
    methods: {
      handleClick(tab, event) {

        console.log(tab, event);
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
        this.activeIndex = key

      },
      mouseover(name) {
        this.isShow = true
        // console.log(this.$refs.secondDown.index);
        // console.log(this.activeIndex2);
        console.log(this);
      },
      mouseLeave() {
        console.log('离开');
        this.isShow = false
        console.log(this.isShow);
      },
      initFacebookJs() {
        (function (d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s);
          js.id = id;
          // js.src = 'https://connect.facebook.net/zh_HK/sdk/xfbml.customerchat.js';
          js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        window.fbAsyncInit = function () {
          FB.init({
            xfbml: true,
            version: 'v6.0'
          });
          FB.Event.subscribe('customerchat.dialogHide', function (a) {
            console.log("对话框隐藏 customerchat.dialogHide", a)
          });
          FB.Event.subscribe('customerchat.dialogShow', function (b) {
            console.log("对话框显示customerchat.dialogShow", b)
          });
          FB.Event.subscribe('customerchat.show', function (c) {
            console.log("插件展示.show", c)
          });
          FB.Event.subscribe('customerchat.hide', function (d) {
            console.log("插件隐藏.hide", d)
          });
        };
      },
      isPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
          "SymbianOS", "Windows Phone",
          "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      }
    },
    mounted() {
      // this.hotTop = this.$refs.hotBanner.offsetHeight
      // console.log(this.$refs.hotBanner.offsetHeight);
    },
    created() {
      this.initFacebookJs();
      let aa = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (aa >= 1900) {
        this.paddingNum = '0 210px'
        this.mr = '210px'
        this.itemW = (aa - 210) / 4 - 10 * 2
      } else {
        this.paddingNum = '0 100px',
          this.mr = '100px'
        this.itemW = (aa - 100) / 4 - 10 * 2
      }
      var flag = this.isPC();
      /*true为PC端，false为手机端
      alert("true为PC端，false为手机端:  ==>" + flag);*/
      console.log("app.vue : true为PC端，false为手机端:  ==>", flag);
      console.log("选择语言为" + this.$i18n.locale + "::===>");
    },
  }
</script>

<style>
  #app {
    font-family: '微软雅黑';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #242320;
    margin: 0 auto;
  }

  * {
    padding: 0;
    margin: 0;
  }
  html {
    padding: 0;
    margin: 0;
  }
  body {
    padding: 0;
    margin: 0;
  }
  button {
    border: none;
  }
  a {
    text-decoration: none;
    color: #1E1303;
  }

  .l {
    float: left;
  }

  .r {
    float: right;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
  }

  .container_fluid {
    width: 100%;
    position: relative;
  }

  .clearFix {
    content: '';
    display: block;
    clear: both;
    /*overflow: hidden;*/
  }

  .clear:after {
    content: '';
    display: block;
    clear: both;
  }

  input {
    outline: none;
    background: none;
    border: 0px;
  }

  input:focus {
    outline: none;
  }

  .displayR {
    display: flex;
    flex-direction: row;
  }

  .displayC {
    display: flex;
    flex-direction: column;
  }

  .displayF {
    justify-content: center;
    align-items: center;
  }

  ul, li {
    padding: 0;
    margin: 0;
  }

  li {
    list-style: none;
  }

  .banner > .el-carousel__container {
    width: 100%;
    height: 100%;
  }

  .banner > .el-carousel__indicators--outside {
    position: absolute;
    bottom: 0;
    z-index: 999;
    left: 50%;
    margin-left: -76px;
  }

  .banner .el-carousel__indicators--outside button {
    background-color: #333;
  }

  /*.el-menu--horizontal>.el-menu-item[data-v-1ff350c2]:hover{*/
  /*color: #BAA069!important;*/
  /*}*/
  .sizeBox .el-icon-arrow-up:before {
    content: "\e79a" !important;
    color: #1E1303;
  }

  .sizeBox .el-select .el-input .el-select__caret {
    -webkit-transition: 0s;
    -moz-transition: 0s;
    -ms-transition: 0s;
    -o-transition: 0s;
    transition: 0s;
  }

  input::-webkit-input-placeholder { /* WebKit browsers */
    color: #C5BBB0;
  }

  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #C5BBB0;
  }

  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #C5BBB0;
  }

  input:-ms-input-placeholder { /* Internet Explorer 10+ */
    color: #C5BBB0;
  }

  .el-menu {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .el-menu--horizontal > .el-menu-item {
    position: relative;
    color: #242320 !important;
    width: 12%;
    text-align: center;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid transparent !important;
    color: #BAA069 !important;
  }

  .header .el-menu--horizontal > .el-menu-item.is-active::after {
    content: '';
    display: block;
    width: 20px;
    height: 2px;
    background-color: #BAA069;
    position: absolute;
    left: 50%;
    margin-left: -10px;

  }

  .chooseBox .el-carousel__container {
    height: 429px !important;
  }

  .chooseBox .el-carousel__item[data-v-6ce149d5]:nth-child(2n+1),
  .chooseBox .el-carousel__item[data-v-6ce149d5]:nth-child(2n) {
    background-color: #faf8f6;
  }

  .el-menu-item:hover {
    color: #BAA069 !important;
  }

  .downMaskBanner {
    width: 70%;
    /*padding: 45px 0;*/
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    float: right;
  }

  .downMaskBanner > img {
    width: 100%;
  }

  .seriesName {
    height: 100%;
    width: 150px;
    /*margin-right: 100px;*/
    margin-top: 45px;
  }

  .seriesName .type div {
    padding: 4px 0;
  }

  .seriesTitle {
    color: #3E3C39;
    margin-bottom: 20px;
    font-size: 16px;
  }

  .divide {
    width: 1px;
    height: 166px;
    background-color: #ddd;
    margin-right: 60px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .el-input__inner {
    background-color: #F7F5F1;
  }

  .el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #ddd;
  }

  .area-select .area-selected-trigger {
    background-color: #F7F5F1;

  }

  .rightProfile .area-select.medium {
    border-color: #ddd;
    margin-bottom: 30px;

    margin-left: 0;
  }

  .rightProfile .area-select.medium:nth-child(2n) {
    float: right;
    margin-right: 30px;
  }

  .rightProfile .area-select:hover {
    border-color: #ddd;
  }

  .el-menu[data-v-1ff350c2] {
    width: 80% !important;
  }

  .productImg .mouse-cover {
    position: absolute;

  }

  .mouse-cover-canvas {
    border: 1px solid #000 !important;
    top: 400px !important;
    left: 705px !important;
    background-color: #fff !important;
  }

  .mouse-cover {
    width: 100px !important;
    height: 100px !important;
  }

  .item .el-badge__content.is-fixed {
    -webkit-box-sizing: border-box !important;
    -moz-box-sizing: border-box !important;
    box-sizing: border-box !important;
    padding: 0 2px;
  }



  /*我的账户*/
  .phoneCall .el-input__inner {
    background-color: #F7F5F1 !important;
    border-color: #bbb !important;
    width: 100%;

  }

  .phoneCallBox .el-input__inner {
    width: 83%;
    margin-right: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .area .area-select-wrap .area-select {
    width: 21%;
    margin-left: 0 !important;
    height: 40px;
    margin-right: 40px;

  }

  .area .area-selected-trigger {
    line-height: 25px;
  }

  .area-select:hover {
    border-color: #DCDFE6;
  }

  /*放大镜*/
  .vue-magnify .preview-box .hover-box[data-v-0443e94f] {
    background-image: none !important;
    -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1) !important;
    -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1) !important;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1) !important;
    background-color: rgba(255, 255, 255, 0.3) !important;
    border-color: rgba(75, 73, 70, 0.3) !important;
  }

  .paymentTerms .el-radio__label {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paymentTerms .el-cascader-node > .el-checkbox, .el-cascader-node > .el-radio, .el-radio:last-child {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .terms .el-radio-group {
    display: flex;
    flex-direction: row;
  }

  .terms .el-radio__input.is-checked + .el-radio__label {
    color: #7A7977;
  }

  .terms .el-radio-group > div {
    margin-right: 20px;
  }

  .terms .el-radio__label > img {
    margin-bottom: 10px;
  }

  .accountMask .active[data-v-1ff350c2]:after {
    content: '';
    width: 0 !important;
    height: 0 !important;
    background-color: transparent !important;
  }

  .accountMask .active[data-v-1ff350c2] {
    color: #000 !important;
  }

  .show-list .active[data-v-62d6ae7c] {
    border: none !important;
  }

  .downMask .active[data-v-1ff350c2]:after {
    content: '';
    width: 0;
    height: 0;
  }

  /*input边框颜色*/
  .el-select .el-input.is-focus .el-input__inner,
  .el-select .el-input__inner:focus {
    border-color: #ddd;
  }
  .pointer {
    cursor: pointer;
  }

  .selectedTitle {
    font-size: 14px;
    padding: 23px 0;
    margin: 0 auto;
    width: 1200px;
  }
  .selectedTitle span {
    color: #7A7977;
    cursor: pointer;
  }
  .selectedTitle>img {
    width: 9px;
    height: 9px;
  }
  .selectItem {
    cursor: default !important;
    color: #1E1303 !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue